import floraTheme from "../assets/themes/theme";

export const drawerWidth = 250;
export const mainColor= floraTheme.palette.secondary.main;